// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-stores-index-list-ejdtb{display:grid;grid-gap:24px}.pages-stores-index-list-ejdtb.pages-stores-index-desktop-ivznx{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-stores-index-list-ejdtb",
	"desktop": "pages-stores-index-desktop-ivznx"
};
module.exports = ___CSS_LOADER_EXPORT___;
